const comments = [
  { name: '漫画迷小王', text: '终于找到一个靠谱的免费漫画站了！韩漫资源特别全，更新速度也很快，追了好几部都同步最新话。', time: '2小时前', avatar: '王' },
  { name: '二次元少女', text: '界面很清爽，没有乱七八糟的广告。日漫分类做得特别好，按类型找漫画超级方便，收藏功能也很实用。', time: '5小时前', avatar: '二' },
  { name: '熬夜追漫人', text: '每天晚上必刷酷看！玄幻和热血漫画最对我胃口，画质清晰加载快，移动端体验也很流畅。', time: '1天前', avatar: '追' },
  { name: '漫画推荐官', text: '国漫专区越来越有看头了，很多原创作品质量很高。排行榜功能帮我发现不少宝藏漫画。', time: '2天前', avatar: '推' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">读者热评</h2>
          <p className="text-sm text-foreground-500">来自真实漫画读者的使用反馈</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {comments.map((item) => (
            <div key={item.name} className="p-5 rounded-xl bg-background-100">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center font-bold text-sm flex-shrink-0">{item.avatar}</div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}